export default function LandingPage() {
  const isMobile = window.innerWidth <= 900;

  return (
    <div
      style={{
        background: "#071120",
        color: "#ffffff",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
        overflow: "hidden"
      }}
    >
      {/* HERO */}

<section
  style={{
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    background:
      "radial-gradient(circle at top right, rgba(37,99,235,.25), transparent 35%), linear-gradient(180deg,#071120 0%, #0d1b34 100%)"
  }}
>
  <div
    style={{
      maxWidth: "1280px",
      width: "100%",
      margin: "0 auto",
      padding: "clamp(60px,8vw,120px) clamp(20px,5vw,30px)",
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(350px,1fr))",
      gap: "clamp(30px,5vw,70px)",
      alignItems: "center",
      boxSizing: "border-box"
    }}
  >
    {/* TEXTO */}

    <div
      style={{
        width: "100%"
      }}
    >
      <div
        style={{
          display: "inline-block",
          background: "rgba(59,130,246,.12)",
          border: "1px solid rgba(59,130,246,.35)",
          color: "#60a5fa",
          padding: "12px 18px",
          borderRadius: "999px",
          fontSize: "clamp(12px,2vw,14px)",
          marginBottom: "25px"
        }}
      >
        Plataforma inteligente de automação com IA
      </div>

      <h1
        style={{
          fontSize: "clamp(42px,7vw,78px)",
          fontWeight: 800,
          lineHeight: 1.05,
          marginBottom: "30px"
        }}
      >
        Automatize processos com{" "}
        <span
          style={{
            color: "#3b82f6"
          }}
        >
          Inteligência Artificial
        </span>{" "}
        e reduza custos operacionais
      </h1>

      <p
        style={{
          fontSize: "clamp(16px,2vw,19px)",
          color: "#94a3b8",
          lineHeight: 1.8,
          marginBottom: "40px",
          maxWidth: "650px"
        }}
      >
        Criamos automações personalizadas para empresas que desejam
        escalar atendimento, eliminar tarefas repetitivas e integrar
        WhatsApp, CRM, APIs, financeiro, e-mails e processos internos.
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
          marginBottom: "45px"
        }}
      >
        <a
          href="https://wa.me/5583996618187"
          style={{
            background: "#2563eb",
            color: "#fff",
            textDecoration: "none",
            padding: "18px 32px",
            borderRadius: "16px",
            fontWeight: "bold",
            textAlign: "center",
            flex: "1 1 240px",
            boxSizing: "border-box"
          }}
        >
          Falar no WhatsApp
        </a>

        <a
          href="https://wa.me/5583996618187?text=Olá!%20Gostaria%20de%20solicitar%20um%20teste%20gratuito."
          style={{
            border: "1px solid rgba(255,255,255,.15)",
            color: "#fff",
            textDecoration: "none",
            background: "rgba(255,255,255,.05)",
            padding: "18px 32px",
            borderRadius: "16px",
            textAlign: "center",
            flex: "1 1 240px",
            boxSizing: "border-box"
          }}
        >
          Teste Gratuito
        </a>
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px"
        }}
      >
        {[
          "Agentes IA",
          "WhatsApp",
          "Gmail",
          "Google Agenda",
          "CRM",
          "APIs"
        ].map((item) => (
          <div
            key={item}
            style={{
              padding: "10px 18px",
              borderRadius: "999px",
              background: "rgba(255,255,255,.05)",
              color: "#93c5fd",
              fontSize: "14px"
            }}
          >
            {item}
          </div>
        ))}
      </div>
    </div>

    {/* IMAGEM */}

    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center"
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "560px",
          background: "rgba(255,255,255,.03)",
          border: "1px solid rgba(255,255,255,.08)",
          borderRadius: "30px",
          padding: "20px",
          boxSizing: "border-box",
          backdropFilter: "blur(10px)",
          boxShadow: "0 0 60px rgba(37,99,235,.15)"
        }}
      >
        <img
          src="/lp.png"
          alt="Dashboard"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            borderRadius: "20px"
          }}
        />
      </div>
    </div>
  </div>
</section>
      {/* BENEFÍCIOS */}

      <section
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
          padding: isMobile ? "80px 20px" : "120px 30px"
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "70px"
          }}
        >
          <h2
            style={{
              fontSize: isMobile ? "38px" : "54px",
              marginBottom: "20px"
            }}
          >
            Por que automatizar sua empresa?
          </h2>

          <p
            style={{
              color: "#94a3b8",
              fontSize: "18px"
            }}
          >
            Menos trabalho manual. Mais escala.
          </p>
        </div>

      <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "25px",
    width: "100%"
  }}
>
  {[
    {
      title: "Redução de Custos",
      text: "Automatize tarefas repetitivas e reduza operação manual."
    },
    {
      title: "Atendimento 24/7",
      text: "Agentes inteligentes respondendo clientes sem pausa."
    },
    {
      title: "Escalabilidade",
      text: "Sua empresa atende milhares sem aumentar equipe."
    },
    {
      title: "Integrações Inteligentes",
      text: "Conecte CRM, WhatsApp, APIs, pagamentos e sistemas."
    }
  ].map((card, index) => (
    <div
      key={index}
      style={{
        background: "rgba(255,255,255,.03)",
        border: "1px solid rgba(255,255,255,.08)",
        padding: isMobile ? "25px" : "35px",
        borderRadius: "24px",
        width: "100%",
        boxSizing: "border-box"
      }}
    >
      <div
        style={{
          width: "55px",
          height: "55px",
          borderRadius: "16px",
          background: "#2563eb",
          marginBottom: "22px"
        }}
      />

      <h3
        style={{
          fontSize: isMobile ? "20px" : "24px",
          marginBottom: "18px",
          lineHeight: 1.3
        }}
      >
        {card.title}
      </h3>

      <p
        style={{
          color: "#94a3b8",
          lineHeight: "1.8",
          fontSize: isMobile ? "15px" : "16px"
        }}
      >
        {card.text}
      </p>
    </div>
  ))}
</div>
      </section>

      {/* TESTE GRATUITO */}

<section
  style={{
    padding: "80px 20px",
    background: "linear-gradient(180deg,#0d1b34 0%, #071120 100%)"
  }}
>
  <div
    style={{
      maxWidth: "1200px",
      width: "100%",
      margin: "0 auto",
      background: "rgba(255,255,255,.04)",
      border: "1px solid rgba(255,255,255,.08)",
      borderRadius: "24px",
      padding: "clamp(25px,5vw,70px)",
      textAlign: "center",
      boxSizing: "border-box"
    }}
  >
      <div
        style={{
          display: "inline-block",
          padding: "10px 18px",
          borderRadius: "999px",
          background: "rgba(37,99,235,.15)",
          color: "#60a5fa",
          marginBottom: "25px",
          fontWeight: "bold"
        }}
      >
        🎁 TESTE GRATUITO
      </div>

      <h2
        style={{
          fontSize: "clamp(32px,6vw,58px)",
          lineHeight: 1.1,
          marginBottom: "25px"
        }}
      >
        Veja uma automação funcionando na sua empresa.
      </h2>

      <p
        style={{
          maxWidth: "800px",
          width: "100%",
          margin: "0 auto 45px",
          color: "#94a3b8",
          lineHeight: "1.8",
          fontSize: "clamp(16px,2vw,18px)"
        }}
      >
        Antes de contratar, mostramos na prática como uma automação pode
        transformar o atendimento, vendas e processos internos da sua empresa.
        Nossa equipe fará uma demonstração personalizada utilizando um processo
        real do seu negócio.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
          gap: "20px",
          marginBottom: "45px"
        }}
      >
        {[
          "✅ Demonstração personalizada",
          "⚡ Sem compromisso",
          "🤖 Agente configurado para seu negócio"
        ].map((item) => (
          <div
            key={item}
            style={{
              background: "rgba(255,255,255,.05)",
              padding: "20px",
              borderRadius: "18px",
              fontWeight: "bold",
              width: "100%",
              boxSizing: "border-box"
            }}
          >
            {item}
          </div>
        ))}
      </div>

      <a
        href="https://wa.me/5583996618187?text=Olá!%20Gostaria%20de%20solicitar%20meu%20teste%20gratuito."
        target="_blank"
        rel="noreferrer"
        style={{
          display: "inline-block",
          width: "100%",
          maxWidth: "420px",
          background: "#2563eb",
          color: "#fff",
          textDecoration: "none",
          padding: "18px 25px",
          borderRadius: "18px",
          fontSize: "clamp(16px,2vw,20px)",
          fontWeight: "bold",
          boxSizing: "border-box"
        }}
      >
        🚀 Solicitar Teste Gratuito
      </a>

      <p
        style={{
          marginTop: "25px",
          color: "#64748b",
          fontSize: "14px"
        }}
      >
        Sem cartão de crédito • Sem compromisso • Atendimento rápido
      </p>
  </div>
</section>

      {/* CTA */}

      <section
        style={{
          padding: "100px 20px",
          background: "#08101d",
          textAlign: "center"
        }}
      >
        <h2
          style={{
            fontSize: isMobile ? "36px" : "58px",
            maxWidth: "900px",
            margin: "0 auto",
            marginBottom: "25px"
          }}
        >
          Sua empresa ainda perde tempo fazendo trabalho manual?
        </h2>

        <p
          style={{
            color: "#94a3b8",
            maxWidth: "700px",
            margin: "0 auto",
            marginBottom: "40px",
            lineHeight: "1.8"
          }}
        >
          Criamos automações sob medida com Inteligência Artificial
          para vendas, atendimento, suporte, operações e processos internos.
        </p>

        <a
          href="https://wa.me/5561990008359"
          style={{
            background: "#2563eb",
            color: "white",
            padding: "18px 40px",
            borderRadius: "18px",
            textDecoration: "none",
            fontWeight: "700"
          }}
        >
          Quero automatizar meu negócio
        </a>
      </section>
    </div>
  );
}